/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>log.service.ts</name>
///
/// <description>
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sept16 MM  1.0.0000         First cut
/// 12Dec16  SG  1.0.0000         Adding Calls to Log API; Set additional properties in error message
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import {HydUser} from "../models/user";
import {hydUtilService} from "../utils/hydUtils.service";
import {Environment} from '../host.environment';
import {LogApiService, LogEntry, Severity} from './Crestron.HydrogenAPI.LogApi.service'
import { Subscription } from 'rxjs/Subscription';
import { HydrogenAppConfigService } from '../host.config.service';

@Injectable()
export class LogService {
    private logEntrySubscription: Subscription;        
    private baseUrl: string = undefined;

    constructor(configSvc: HydrogenAppConfigService, private http: Http, private hydUser: HydUser, private logApiService: LogApiService) {
        this.baseUrl = configSvc.config.serviceUrl.log;
                             this.logApiService = new LogApiService(this.http,  this.baseUrl );                            
                }

    logLogEntry(logEntry: LogEntry) {
        try {
            console.log(hydUtilService.TimeStamp() + " " + logEntry.message);
            /*
         this.setLogEntryProperties(logEntry)
          
         this.logApiService.createLogEntry(logEntry)
                            .toPromise( )
                            .catch(function() {console.log("Unable to Log Message")});
           */
        }
        catch(exception)
        {
            console.log("Could not write entry to log");
        }
    }

    logMessage(message) {      
        try {     
                console.log(hydUtilService.TimeStamp() + " " + message);
             /*
           let logEntry : LogEntry = new LogEntry()
           logEntry.message = message;     
           this.setLogEntryProperties(logEntry)
           
          
           this.logApiService.createLogEntry(logEntry)
                             .toPromise()
                             .catch(function() {console.log("Unable to Log Message")});
             */                            
        }
        catch(exception)
        {
            console.log("Could not write message to log");
        }        
    }


    private setLogEntryProperties(logEntry: LogEntry)  {
            let userName : string = "Unknown";
            if (this.hydUser.GivenName && this.hydUser.LastName) {
                userName = this.hydUser.GivenName + " " + this.hydUser.LastName;
            }                            
            logEntry.userId = this.hydUser.UserId + (userName);
            logEntry.accountId = this.hydUser.AccountId;
            
    }
 
}
  

   // this.hydUser.AccessToken


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/log.service.ts